import { useParams, useHistory, useLocation } from "react-router";
import React, { useEffect, useState } from "react";

const PlayTvShow = () => {
  const { showid, videourl } = useParams();
  const history = useHistory();
  const location = useLocation();
  const [currentVideoIndex, setCurrentVideoIndex] = useState(null);

  useEffect(() => {
    if (location.state?.season) {
      // Find the index of the current video
      const index = location.state.season.findIndex(
        (video) => video.lesson_id.video.split("/videos/")[1] === videourl
      );
      setCurrentVideoIndex(index);
    }
  }, [videourl, location.state]);

  const handleVideoEnd = () => {
    if (currentVideoIndex !== null && location.state?.season) {
      // Get the next video in the sequence
      const nextIndex = currentVideoIndex + 1;
      const nextVideo = location.state.season[nextIndex];

      if (nextVideo) {
        // If there is a next video, navigate to the next video
        history.push(
          `/tvshow/play/${showid}/${
            nextVideo.lesson_id.video.split("/videos/")[1]
          }`,
          { season: location.state.season } // Passing the season state for navigation
        );
      } else {
        // If it's the last video in the season, navigate back to the show overview page
        history.push(`/tvshowview/${showid}`);
      }
    }
  };
  return (
    <>
      <div>
        <div
          style={{
            position: "relative",
            width: "100%",
            height: "100vh",
            overflow: "hidden",
          }}
        >
          <video
            // Required for iOS to play inline rather than taking over the screen.
            playsInline
            id="player"
            // onPause={pouseHander}
            // src={`https://sgp1.digitaloceanspaces.com/storage.tellytell.com/video-${videourl}`}
            src={`https://res.cloudinary.com/duenuiiav/video/upload/v1649441298/videos/${videourl}`}
            style={{
              width: "100%",
              height: "100%",
              border: "none",
              position: "absolute",
              left: "0",
              top: "0",
              minWidth: "100%",
            }}
            controls
            autoPlay={true}
            onEnded={handleVideoEnd}
          ></video>
        </div>
      </div>
    </>
  );
};
export default PlayTvShow;
